import { Dropdown, Menu } from "antd"
import PropTypes from "prop-types"

// Para utilizar este componente es necesario agregar la tag div como children o cualquier otra para que el componente
// de ant d reconozca que existe algo de lo contrario no muestra el menu con hover ni ninguna otra opcion
const CustomDropdown = ({
  typeShowMenu = 'hover',
  placement = 'bottomLeft',
  styleMenu,

  items = [],
  children,
  overlayClassName,
  className,
}) => {

  const menu = items.length > 0 ? (
    <Menu
      style={styleMenu}
      items={items.map((item) => ({
        key: item.key,
        disabled: item?.disabled,
        className: item?.className,
        label: <ItemLabel item={item} />,
      }))}
    />
  ) : <></>

  return (
    <Dropdown
      overlay={menu}
      trigger={[typeShowMenu]}
      placement={placement}
      overlayClassName={overlayClassName}
      className={className}      
    >
      {children}
    </Dropdown>
  )
}

const ItemLabel = ({ item }) => {
  return (
    <div
      role="none"
      className="more-options-standard"
      onClick={() => item?.action?.(item.key)}
    >
      {item.icon ?? <></>}
      <span
        style={{
          gridColumn: item.icon ? 'span 4' : 'span 5',
        }}
      >{item.label}</span>
    </div>
  )
}

ItemLabel.propTypes = {
  item: PropTypes.object,
}

CustomDropdown.propTypes = {
  typeShowMenu: PropTypes.string,
  placement: PropTypes.string,
  styleMenu: PropTypes.object,
  items: PropTypes.array,
  children: PropTypes.node,
  overlayClassName: PropTypes.string,
  className: PropTypes.string,
}

export default CustomDropdown
